// Delete Regularusers Group
export const DELETE_REGULARUSERS_GROUP_REQUEST = 'DELETE_REGULARUSERS_GROUP_REQUEST';
export const DELETE_REGULARUSERS_GROUP_DONE = 'DELETE_REGULARUSERS_GROUP_DONE';
export const DELETE_REGULARUSERS_GROUP_FAILED = 'DELETE_REGULARUSERS_GROUP_FAILED';
